import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BuildConfigService } from '@common/util-foundation';
import {
  AddBundleApplianceAPIRequestData,
  RemoveBundleAppliancesAPIRequestData,
  SkyBasket,
  SkyCreateQuoteRequest,
  SkyCreateQuoteResponse,
} from '@sky/util-models';
import { map } from 'rxjs/operators';

@Injectable()
export class BasketApiService {
  constructor(
    private httpClient: HttpClient,
    private buildConfigService: BuildConfigService
  ) {}

  createQuote(createQuoteParams: SkyCreateQuoteRequest) {
    const config = this.buildConfigService.config;
    const createQuoteUrl = `${config.basketApi}/quote`;
    return this.httpClient
      .post<{ result: SkyCreateQuoteResponse }>(
        createQuoteUrl,
        createQuoteParams,
        {
          headers: this.headers,
        }
      )
      .pipe(
        map((response: { result: SkyCreateQuoteResponse }) => response.result)
      );
  }

  addAppliances(addAppliancesParams: AddBundleApplianceAPIRequestData) {
    const config = this.buildConfigService.config;
    const addAppliancesQuoteUrl = `${config.basketApi}/add-appliances`;
    return this.httpClient
      .post<{ result: SkyBasket }>(addAppliancesQuoteUrl, addAppliancesParams, {
        headers: this.headers,
      })
      .pipe(map((response: { result: SkyBasket }) => response.result));
  }

  removeAppliances(
    removeAppliancesParams: RemoveBundleAppliancesAPIRequestData
  ) {
    const config = this.buildConfigService.config;
    const removeAppliancesUrl = `${config.basketApi}/remove-appliances`;
    return this.httpClient
      .post<{ result: SkyBasket }>(
        removeAppliancesUrl,
        removeAppliancesParams,
        {
          headers: this.headers,
        }
      )
      .pipe(map((response: { result: SkyBasket }) => response.result));
  }

  private get headers(): { [key: string]: string } {
    return {
      'wl-client': this.buildConfigService.config.wlClient,
      'request-source': this.buildConfigService.config.catalogueStore,
      'request-action': this.buildConfigService.config.action,
    };
  }
}
